<script setup>
import { computed } from 'vue';
import icon01 from '@/assets/images/result/ai/icon_01.svg';
import icon02 from '@/assets/images/result/ai/icon_02.svg';
import icon03 from '@/assets/images/result/ai/icon_03.svg';
import icon04 from '@/assets/images/result/ai/icon_04.svg';
import { AREA_CODES, AREA_NAMES } from './data/reportData';
import { resolveAreaLevelKey, areaLevelComment, levelKeyToKo } from './data/reportLogic';

const icons = [icon01, icon02, icon03, icon04];

const props = defineProps({
  userRole: {
    type: String,
    default: 'student'
  },
  studentData: {
    type: Object,
    default: null
  }
});

// 학생 데이터가 없을 때(학부모 목업 등) 기본 표시: 각 영역 '중' 문구
const displayRows = computed(() => {
  const data = props.studentData || {};
  const schulType = data.schul_type || 'E';
  return AREA_CODES.map((code, index) => {
    const rawLevel = data[`field${index + 1}_level`];
    const score = data[`field${index + 1}_score`];
    const levelKey = resolveAreaLevelKey(schulType, code, rawLevel, score);
    return {
      title: AREA_NAMES[index],
      level: levelKeyToKo(levelKey),
      content: areaLevelComment(schulType, code, levelKey)
    };
  });
});
</script>
<template>
  <div class="card area-guide pt-5">        
    <div class="ai-table primary">
      <div class="row thead">
        <div class="th">영역</div>
        <div class="td">영역별 성취 설명</div>
      </div>
      <div class="row" v-for="(row, index) in displayRows" :key="index">
        <div class="th">
          <img :src="icons[index]" alt="icon">
          <p v-html="row.title"></p>
        </div>
        <div class="td">{{ row.content }}</div>
      </div>
    </div>    
  </div>
</template>

<style lang="scss" scoped>
    .report-inner .ai-table {
      border-bottom: 0;
      .row {
        &.thead > div {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        > div {      
          &.th { 
            flex-direction: column;
            p { font-size: 1.125rem; font-weight: 600; color: var(--result-ai-primary-800); }
          }      
          &.td {
            line-height: 1.6;
            text-align: justify;
            word-break: keep-all;
            text-justify: inter-word;
            display: flex;
            align-items: center;
          }
        }
        // 영역별 성취 설명 문구 (머리행 제외)
        &:not(.thead) > div.td { font-size: 20px; }
      }
    } 
</style>